<template>
  <update-logs
    path="getmobileclients"
    type="mobileclients"
  />
</template>
<script>
import UpdateLogs from "../modules/UpdateLogs.vue";

export default {
  name: "MobileClientsUpdateLogs",
  components: {
    UpdateLogs
  }
};
</script>



// WEBPACK FOOTER //
// MobileClientsUpdateLogs.vue?07a79a72